// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__TKx9V","boxTitle":"Qualiphy_boxTitle__3h9xo","box":"Qualiphy_box__3XDhV","toggleWrap":"Qualiphy_toggleWrap__1Gfga"};